module.exports = __webpack_public_path__ + "static/media/LaurenAndersonAssociates_Logo.468afe16.bmp";